import type { RootState } from '../store';

export const getAdminPageSearch = (state: RootState) => state.adminPage.search;

export const getAdminPageAgency = (state: RootState) => state.adminPage.agency;
